import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { queries } from "../../Infrastructure/const/queries";

export const publicationAPI = createApi({
    reducerPath: 'publicationAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: queries.baseURL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('userToken');
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),

    // ✅ добавляем тип тегов
    tagTypes: ['Publications', 'Categories'],

    endpoints: (build) => ({

        fetchPublicationsByIdCategory: build.query({
            query: (categoryId) => ({
                url: `categories/${categoryId}/publications`,
                method: 'GET',
            }),
            providesTags: ['Publications'], // 👈 зависит от публикаций
        }),

        fetchPublication: build.query({
            query: (publicationId) => ({
                url: `publications/${publicationId}`,
                method: 'GET',
            }),
            providesTags: ['Publications'],
        }),

        createPublication: build.mutation({
            query: (body) => ({
                url: `publications`,
                method: 'POST',
                body
            }),
            invalidatesTags: ['Publications', 'Categories'], // 👈 обновляем список после создания
        }),

        updatePublication: build.mutation({
            query: ({ id, body }) => ({
                url: `publications/${id}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: ['Publications'], // 👈 обновляем список после редактирования
        }),

        deletePublication: build.mutation({
            query: (id) => ({
                url: `publications/${id}`,
                method: 'DELETE',

            }),
            invalidatesTags: ['Publications'], // 👈 обновляем список после редактирования
        }),

        fetchPublicationsWithUser: build.query({
            query: () => ({
                url: 'publications-with-users',
                method: 'GET'
            }),
            providesTags: ['Publications'], // 👈 зависит от публикаций
        }),

        markAsRead: build.mutation({
            query: (id) => ({
                url: `publications/${id}/read`,
                method: 'POST'
            }),
            invalidatesTags: ['Publications', 'Categories'], // 👈 после отметки как прочитано
        }),

        fetchAllCategories: build.query ({
            query: () => ({
                url: queries.getCategories,
                method: 'GET',
            }),
            providesTags: ['Categories']
        }),

    })
});
